export default "__VITE_ASSET__CGJAYbY5__"